import { INLINE_CONTENT_BYTES, MAX_CONTENT_BYTES, CONTENT_PART_BYTES } from './limits.js';
export async function uploadContent(content, api, previous = null, progress = () => {}) {
  if (previous?.content_ref && content === previous.content) return { content: '', content_ref: previous.content_ref };
  const bytes = new TextEncoder().encode(content);
  if (bytes.length > MAX_CONTENT_BYTES) throw new Error('筆記內容超過 50 MB');
  if (bytes.length <= INLINE_CONTENT_BYTES) return { content, content_ref: null };
  const parts = [];
  for (let offset = 0; offset < bytes.length;) {
    let end = Math.min(offset + CONTENT_PART_BYTES, bytes.length);
    while (end < bytes.length && (bytes[end] & 0xc0) === 0x80) end--;
    parts.push(new TextDecoder('utf-8', { fatal: true }).decode(bytes.subarray(offset, end))); offset = end;
  }
  const upload = await api('content-uploads', { method: 'POST', body: { totalBytes: bytes.length, partCount: parts.length } });
  for (let index = 0; index < parts.length; index++) {
    await api('content-uploads/' + upload.id + '/parts/' + index, { method: 'PUT', headers: { 'content-type': 'text/plain; charset=utf-8' }, body: parts[index] });
    progress(index + 1, parts.length);
  }
  await api('content-uploads/' + upload.id + '/complete', { method: 'POST', body: {} });
  return { content: '', content_ref: upload.id };
}
export async function loadContent(url) {
  const response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) throw new Error('無法讀取筆記內容');
  const meta = await response.json(), parts = [];
  for (let index = 0; index < meta.partCount; index++) {
    const part = await fetch(meta.partUrl + index, { credentials: 'same-origin' });
    if (!part.ok) throw new Error('無法讀取筆記分段，請重新整理');
    parts.push(await part.text());
  }
  return parts.join('');
}
